import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Campaign,
  CampaignInventory,
  Character,
  CharacterInventory,
} from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterManageInventory from "@dndComponents/character/inventory/manage/CharacterManageInventory";
import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';

interface Props {
  char: Character | Campaign;
  inventory: CharacterInventory | CampaignInventory;
  disabled: boolean;
  shared: boolean;
}

export default function CharacterManageInventoryButton({
  char,
  inventory,
  disabled,
  shared,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          char.subscription_holder.modalClosed();
        }}>
        { open &&
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterManageInventory
                obj={char}
                inventory={inventory}
                shared={shared}
              />
            </Grid>
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <DandDButtonBox
        name={ "Manage Inventory" }
        disabled={disabled}
        onClick={() => {
          setOpen(true);
        }}
      />
      { renderExtras() }
    </>
  )
}
